<p-tabs value="{{activeTabIndex}}">
  <p-tablist style="display: flex; align-items: center;" class="container-style px-0 py-1">
    <p-tab (click)="handleTabChange(0)" value="0">Consulta General</p-tab>
    <p-tab (click)="handleTabChange(1)" value="1">Consulta Detalle</p-tab>
    <p-tab (click)="handleTabChange(2)" value="2">Consulta Concepto</p-tab>
    <app-custom-button class="widthBtns" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
      [severity]="'success'" [variant]="undefined" (onClick)="newInvoice()"></app-custom-button>
  </p-tablist>
  <p-tabpanels class="container-style mt-2">
    <p-tabpanel value="0">
      <app-custom-table [showExport]="true" [showRecover]="true" [headers]="generalHeader" [data]="generalData"
        [actions]="tableActions" [previousFilters]="filters" [filterPersistentKey]="'invoice'"
        (onRecoverData)="getInvoicesWithPagination()" (onPageChange)="onPageChange($event)"
        (onFilterChange)="onFilterChange($event)" (onExport)="onExport()"
        (onAction)="onAction($event)"></app-custom-table>
    </p-tabpanel>
    <p-tabpanel value="1">
      <app-custom-table [showExport]="true" [showRecover]="true" [headers]="detailHeader.columns" [data]="detailData"
        [actions]="tableActions" [previousFilters]="filters" [listStoreConsolidated]="listStoreConsolidated"
        [storeConsolidated]="storeConsolidated" [filterPersistentKey]="'invoice'"
        (onRecoverData)="getAllInvoiceDetailsWithPagination()" (onPageChange)="onPageChange($event)"
        (onFilterChange)="onFilterChange($event)" (storeConsolidatedEmit)="onStoreConsolidatedChange($event)"
        (onExport)="onExport()" (onAction)="onAction($event)"></app-custom-table>
    </p-tabpanel>
    <p-tabpanel value="2">
      <app-custom-table [showExport]="true" [showRecover]="true" [headers]="conceptHeader.columns" [data]="conceptData"
        [actions]="tableActions" [previousFilters]="filters" [listStoreConsolidated]="listStoreConsolidated"
        [storeConsolidated]="storeConsolidated" [filterPersistentKey]="'invoice'"
        (onRecoverData)="getAllInvoiceConceptsWithPagination()" (onPageChange)="onPageChange($event)"
        (onFilterChange)="onFilterChange($event)" (storeConsolidatedEmit)="onStoreConsolidatedChange($event)"
        (onExport)="onExport()" (onAction)="onAction($event)"></app-custom-table>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>

<app-custom-modal #electronicDocumentInfo [label]="'Información Documento Electrónico'"
  [header]="'Información Documento Electrónico'" [inputs$]="inputsForElectronicDocumentInfo$"
  [children]="componentElectronicDocumentInfo" [width]="'90vw'" hidden>
</app-custom-modal>